/* eslint-disable no-shadow */
import { messages, dealers } from '@/constants/taunt/taunts';
import store from '@/store';

const generateDescription = (providedDealerName = '') => {
  let dealerName = dealers[Math.floor(Math.random() * dealers.length)];
  let messagesArray = messages;
  let userName = '';
  if (providedDealerName) {
    dealerName = providedDealerName;
    messagesArray = messages.filter((message) => message.senderMessage);
  } else {
    userName = store.getters.currentUser?.full_name;
  }
  const messageToUse = messagesArray[Math.floor(Math.random() * messagesArray.length)];

  return {
    receiverMessage: messageToUse.receiverMessage.replace(/\[dealerName\]/g, dealerName).replace(/\[userName\]/g, userName),
    senderMessage: messageToUse.senderMessage.replace(/\[dealerName\]/g, dealerName).replace(/\[userName\]/g, userName),
  };
};

const formulateReceivedTaunt = (auction, messageObj) => {
  let messages = generateDescription();

  if (messageObj) {
    messages = messageObj;
  }

  return {
    timestamp: Date.now(),
    id: Math.random(),
    title: auction.vehicleDisplayName,
    ...messages,
    thumbnail: auction.primaryImage.thumbnail,
    auctionId: auction.id,
    seen: false,
    createdBy: auction.auction.high_bidder,
    endTime: auction.endTime.unix(),
  };
};

const initialState = {
  taunts: [],
  fullPanel: false,
};

export const state = {
  ...initialState,
};

export const mutations = {
  includeTaunt(state, auction) {
    state.taunts.unshift(auction); // place at beginning
  },
  clearTaunts(state) {
    state.taunts = [];
  },
  removeTaunt(state, tauntId) {
    const tauntIndex = state.taunts.findIndex((t) => t.id === tauntId);
    if (tauntIndex !== -1) {
      state.taunts.splice(tauntIndex, 1);
    }
  },
  showPanel(state, show) {
    state.fullPanel = show;
  },
  markTauntSeen(state, tauntId) {
    const tauntIndex = state.taunts.findIndex((t) => t.id === tauntId);
    if (tauntIndex !== -1) {
      state.taunts[tauntIndex].seen = true;
    }
  },
};

export const actions = {
  handleAuctionIntake({ commit }, { auction, messageObj }) {
    const tauntMessage = formulateReceivedTaunt(auction, messageObj);

    commit('includeTaunt', tauntMessage);
  },
  handlePanelShow({ commit }, show) {
    commit('showPanel', show);
  },
  removeTaunt({ commit }, tauntId) {
    commit('removeTaunt', tauntId);
  },
  clearTaunts({ commit }) {
    commit('clearTaunts');
  },
  markTauntSeen({ commit }, tauntId) {
    commit('markTauntSeen', tauntId);
  },
  makeDescription({ rootGetters }, anonymous = false) {
    const user = rootGetters.currentUser;
    const dealerName = user?.activeDealerships?.[user.defaultDealerId]?.name || '';
    return generateDescription(anonymous ? '' : dealerName);
  },
};

export const getters = {
  hasTaunts: (state) => state.taunts.length > 0,
  showingFullPanel: (state) => state.fullPanel,
};

const taunt = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default taunt;
